import { atom } from "recoil"

export const homeOrganizationsRequestIdState = atom<number>({
  key: "atoms/home/homeOrganizationsRequestIdState",
  default: 0,
})
